import { ButtonSpinner, GoogleIcon } from "~/components/auth/signInModalIcons";

// The Google sign-in button: the sign-in modal's light button
// (.twt-signin-secondary in SignInModalStyles.tsx) with the Google mark. On
// the wall, and on the checkout sheet while Clerk's own box loads, it is one
// of the dark icon-only buttons in the row under the "or" divider
// (iconOnly): the mark alone, as in the Whop modal. The full form reads
// "Continue with Google"; the accessible name is always "Continue with
// Google".
type Props = {
  disabled?: boolean;
  busy?: boolean;
  onClick?: () => void;
  /** The visible label; "Continue with Google" unless set. */
  label?: string;
  /** The mark alone, in the row of icon buttons. */
  iconOnly?: boolean;
};

const ACCESSIBLE_NAME = "Continue with Google";

export function GoogleSignInButton({
  disabled = false,
  busy = false,
  onClick,
  label = ACCESSIBLE_NAME,
  iconOnly = false,
}: Props) {
  if (iconOnly) {
    return (
      <button
        type="button"
        className="twt-signin-secondary twt-signin-icon-button"
        disabled={disabled}
        aria-busy={busy || undefined}
        aria-label={ACCESSIBLE_NAME}
        onClick={onClick}
      >
        {busy ? (
          <ButtonSpinner />
        ) : (
          <GoogleIcon size={24} className="twt-signin-button-icon" />
        )}
      </button>
    );
  }
  return (
    <button
      type="button"
      className="twt-signin-secondary"
      disabled={disabled}
      aria-busy={busy || undefined}
      aria-label={label === ACCESSIBLE_NAME ? undefined : ACCESSIBLE_NAME}
      onClick={onClick}
    >
      {busy ? <ButtonSpinner /> : <GoogleIcon className="twt-signin-button-icon" />}
      <span>{label}</span>
    </button>
  );
}
